import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';
import { BroadcasterView } from '../components/broadcaster/BroadcasterView';
import { BroadcasterViewMobile } from '../components/broadcaster/BroadcasterViewMobile';
import { ViewerView } from '../components/viewer/ViewerView';
import { ViewerViewMobile } from '../components/viewer/ViewerViewMobile';
import { EmbeddedView } from '../components/views/EmbeddedView';
import { useActiveBroadcastController } from '../hooks/useActiveBroadcastController';
import { BroadcastStateService } from '../services/broadcaststate/BroadcastStateService';
import { RecordingService } from '../services/recording/RecordingService';
export function BroadcastPage({ embedded }) {
    const activeBroadcast = BroadcastStateService.getOutput().useActiveBroadcast();
    const recordingService = RecordingService.getNotificationInterface();
    useActiveBroadcastController();
    useEffect(() => {
        return () => {
            recordingService.notifyStopRecording();
        };
    }, [recordingService.notifyStopRecording]);
    // is undefined briefly on the first render, when useActiveBroadcastController's location.key has not yet executed
    if (activeBroadcast === undefined) {
        return;
    }
    if (embedded) {
        return _jsx(EmbeddedView, {});
    }
    if (isIOS || isAndroid) {
        return activeBroadcast.myRole === 'broadcaster' ? (_jsx(BroadcasterViewMobile, {})) : (_jsx(ViewerViewMobile, {}));
    }
    return activeBroadcast.myRole === 'broadcaster' ? (_jsx(BroadcasterView, {})) : (_jsx(ViewerView, {}));
}
